import React, {Component} from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, UncontrolledTooltip} from "reactstrap";
import axios from "axios/index";
import {validateComponent, validateField} from "../../../common/validation";
import {decideBankType, deepCopyObject, showAxiosError} from "../../../helper/helper";
import Table from "../../../components/Table/Table";
import Alert from "react-s-alert";
import {request} from "../../../helper/APIUtils";
import SweetAlert from "react-bootstrap-sweetalert";
import MaskedInput from "react-text-mask";
import createIBANMask from "text-mask-addon-iban";
import Select from "../../../local_node_modules/react-select";
import {CustomerBankType, EntegratorIdentifiers} from "../../../helper/enums";
import {EntegratorConf} from "../../../constants";
import {showChemistInformationModal} from "../../../helper/permission";



class CustomerBankInfo extends Component {
	constructor(props) {
		super(props);

		this.state = {
			page: 0,
			size: 5,
			error: {},
			customerBank: {
				bankName: '',
				iban: '',
				type: showChemistInformationModal() ? CustomerBankType.SGK : CustomerBankType.OTHER
			},
			bankList: [],
			deleteModal: false,
			addBankModal: false,
			alert: null
		};

		this.validateField = this.validateField.bind(this);
		this.validateClass = this.validateClass.bind(this);
		this.validateMessage = this.validateMessage.bind(this);
		this.validateComponent = this.validateComponent.bind(this);
		this.isChanged = this.isChanged.bind(this);
		this.updateBankList = this.updateBankList.bind(this);
		this.arrangeData = this.arrangeData.bind(this);
		this.openAddBankModal = this.openAddBankModal.bind(this);
		this.cancelCurrentBank = this.cancelCurrentBank.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
	}

	componentDidMount() {
		this.setState({
			bankList: this.props.customerBankList
		})
	}

	componentWillReceiveProps() {
		this.setState({
			bankList: this.props.customerBankList
		})
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let value = e.target.value;

		let result = validateField(rule, boundary, value);
		let error = this.state.error;

		error = Object.assign(error, {[id]: result});

		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	validateComponent() {
		let result = validateComponent(this);
		this.setState({
			error: result.error
		});
		return result
	}

	addBank() {
		this.props.addBankToCustomer();
		let error = deepCopyObject(this.state.error);
		if (error.tBankName.valid && error.tIban.valid) {
			this.setState({
				addBankModal: false
			})
		}
	}

	saveUpdatedBank() {
		let obj = this.props.customerBank;
		obj.customer = this.props.customer;
		axios.put('/externalCustomer/saveExternalCustomerBank', obj)
			.then(() => this.clearForm())
			.then(() => this.updateBankList(obj))
			.catch(function (error) {
				showAxiosError(error);
			});
	}

	updateBankList(obj) {
		let bankList = JSON.parse(JSON.stringify(this.state.bankList));
		let selectedIndex = this.state.selectedIndex;
		bankList.splice(selectedIndex, 1, obj);
		this.setState({
			bankList: bankList
		})
	}

	openAddBankModal() {
		this.setState({
			addBankModal: true
		})
	}

	handleEdit(data) {
		this.props.fillBankForm(data.original);
		this.setState({
			initCustBankData: data.original,
			selectedIndex: data.index
		})
	}

	handleDelete(data) {
		if(data.recordId === "" && data.iban != null){
			let customerBankList = [];
			this.props.customerBankList.forEach(bank => {
				if (bank.type !== data.type) {
					customerBankList.push(bank);
				} else if (bank.type === data.type) {
					if (bank.iban !== data.iban || bank.bankName !== data.bankName) {
						customerBankList.push(bank);
					}
				}
			});
			this.props.setBankList(customerBankList);
			this.setState({alert: null, notify: null});

		}else{
			let self = this;
			let params = {
				url: "/customer/deleteCustomerBank",
				method: "post",
				data: data.recordId
			};
			request(params)
				.then(function (response) {
					self.props.reload(true, "header");
					Alert.success("Banka başarıyla silindi.", {
						position: 'top-right',
						effect: 'stackslide',
						timeout: 5000
					});
				}).catch(function (error) {
				showAxiosError(error);
			});
		}
	}

	clearForm() {
		this.props.clearForm();
	}

	isChanged(initState, input) {
		if (JSON.stringify(initState) === JSON.stringify(input)) {
			return false
		} else {
			return true
		}
	}

	openDeleteModal(data) {
		this.setState({
			selectedRowId: data.original.recordId,
			selectedRowIndex: data.index,
			deleteModal: true
		})
	}

	arrangeData(page, size) {
		this.setState({
			page: page,
			size: size,
			loading: false
		});
	}

	cancelCurrentBank() {
		this.props.clearCustomerBank();
		this.setState({
			addBankModal: false
		})
	}
	render() {
		let columns = [
			{
				Header: "Banka Adı",
				accessor: "bankName",
				sortable: false
			},
			{
				Header: "IBAN",
				accessor: "iban",
				sortable: false
			}
		];

		if (showChemistInformationModal()) {
			columns.push({
				Header: "Banka Türü",
				accessor: "type",
				sortable: false,
				Cell: row =>
					<div>{decideBankType(row.type)}</div>
			})
		}

		columns.push({
				Header: "",
				Cell: row => (
					<div>
						<button type="button" onClick={() => this.setState({
							alert: (
								<SweetAlert showCancel warning
											confirmBtnText="Evet"
											cancelBtnText="Hayır"
											confirmBtnBsStyle="danger"
											cancelBtnBsStyle="default"
											title="Emin misiniz?"
											onConfirm={() => {
												this.handleDelete(row)
											}}
											onCancel={() => this.setState({alert: null, notify: null})}>
									Banka bilgisi silinecek..! Onaylıyor musunuz ?
								</SweetAlert>
							)
						})} rel="tooltip"
								className="btn btn-danger btn-sm btn-icon "
								style={{margin: "0px", background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}>
							<i className="fa fa-trash"></i>
						</button>
					</div>
				)
			});

		return (
			<div>
				{this.state.alert}
				<div className="col-sm-12 " style={{marginBottom: '20px'}}>
					<nav className="">
						<button type="button" data-toggle="tooltip" data-placement="bottom"
								style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)'}}
								rel="tooltip" className="TekBtn ekle btn-icon"
								onClick={() => {
									this.openAddBankModal()
								}}>
							Yenİ Banka Ekle
						</button>
					</nav>
				</div>

				<div className="card-body">
					<Table
						columns={columns}
						content={this.state.bankList}
						page={this.state.page}
						size={this.state.size}
						paginationEnabled={false}
						total={this.state.bankList.length}
						fetchData={this.arrangeData}
					/>
				</div>

				<Modal isOpen={this.state.deleteModal}>
					<ModalHeader toggle={this.toggle}>Emin misiniz ?</ModalHeader>
					<ModalBody>
						<Button color="primary"
								onClick={() => this.setState({deleteModal: false}, this.handleDelete())}>Onayla</Button>
						<Button color="secondary" onClick={() => this.setState({
							deleteModal: false
						})}>İptal</Button>
					</ModalBody>
				</Modal>

				<Modal isOpen={this.state.addBankModal} size='lg'>
					<ModalHeader toggle={this.cancelCurrentBank}>Yeni Hesap Bilgisi</ModalHeader>
					<ModalBody>
						<div className="row">

							{showChemistInformationModal() &&
								<div className="col-sm-6 row">
									<div className="col-sm-4">
										<label className="col-form-label" style={{whiteSpace: 'nowrap'}}>Banka
											Türü</label>
									</div>
									<div className="col-sm-8" style={{maxWidth: "none"}}>
										<div className={"form-group" + this.validateClass('tBankType')}>
											<Select className="selected-control"
													type="text"
													name="type"
													id="tBankType"
													data-vlength="1,45"
													onBlur={this.validateField}
													ref="tBankType"
													placeholder="Seçiniz..."
													clearable={false}
													value={this.props.customerBank.type}
													options={[
														{label: "SGK", value: CustomerBankType.SGK},
														{label: "KAMU", value: CustomerBankType.KAMU},
														{label: "DİĞER", value: CustomerBankType.OTHER},
													]}
													onChange={(e) => this.props.onChangeCustomerBank(e, "type")}/>
											{this.validateMessage('tBankType') !== "" &&
												<UncontrolledTooltip placement="right" target="tBankType" delay={0}>
													{this.validateMessage("tBankType")}
												</UncontrolledTooltip>}
										</div>
									</div>
								</div>}
							{showChemistInformationModal() && <div className="col-sm-6 row"/>}

							<div className="col-sm-6 row">
								<div className="col-sm-4">
									<label className="col-form-label" style={{whiteSpace: 'nowrap'}}>Banka Adı</label>
								</div>
								<div className="col-sm-8" style={{maxWidth: "none"}}>
									<div className={"form-group" + this.validateClass('tBankName')}>
										{(EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier || EntegratorIdentifiers.SMART === EntegratorConf.identifier || EntegratorIdentifiers.MBT === EntegratorConf.identifier) ?
										//{([EntegratorIdentifiers.KOLAYSOFT &&EntegratorIdentifiers.SMART && EntegratorIdentifiers.MBT].includes(EntegratorConf.identifier)) ?*/
										<Select className="selected-control"
											   type="text"
											   name="bankName"
											   id="tBankName"
											   data-vlength="1,45"
											   onBlur={this.validateField}
											   ref="tBankName"
											   placeholder="Seçiniz..."
											   value={this.props.customerBank.bankName}
												options={this.props && this.props.bankList && this.props.bankList.map(bank => ({
													value: bank.name,
													label: bank.name,
												}))}
										    	onChange={(e) => this.props.onChangeCustomerBank(e, "bankName")}/> :
										<input className="form-control"
												type="text"
												name="bankName"
												id="tBankName"
												data-vlength="1,45"
												onBlur={this.validateField}
												ref="tBankName"
												value={this.props.customerBank.bankName}
												onChange={(e) => this.props.onChangeCustomerBank(e, "bankName")}/>
									}
										{this.validateMessage('tBankName') !== "" &&
										<UncontrolledTooltip placement="right" target="tBankName" delay={0}>
											{this.validateMessage("tBankName")}
										</UncontrolledTooltip>}
									</div>
								</div>
							</div>

							<div className="col-sm-6 row">
								<div className="col-sm-4">
									<label className="col-form-label">IBAN *</label>
								</div>
								<div className="col-sm-8" style={{maxWidth: "none"}}>
									<div className={"form-group" + this.validateClass('tIban')}>
										<MaskedInput className="form-control"
													 mask={createIBANMask('TR')}
													 placeholder={"TR__ ____ ____ ____ ____ ____ __"}
													 id="tIban"
													 type="text"
													 name="iban"
													 ref="tIban"
													 inputProps={{vdata: "iban", vlength: '1,45'}}
													 value={this.props.customerBank.iban}
													 onBlur={this.validateField}
													 onChange={(e) => this.props.onChangeCustomerBank(e, "iban")}/>
										{this.validateMessage('tIban') !== "" &&
										<UncontrolledTooltip placement="right" target="tIban" delay={0}>
											{this.validateMessage("tIban")}
										</UncontrolledTooltip>}
									</div>
								</div>
							</div>
						</div>
					</ModalBody>
					<ModalFooter>
						<nav className=" col-sm-12 row">
							<div className="col-3">
								<button type="button" data-toggle="tooltip" data-placement="bottom"
										style={{background: 'rgb(158, 158, 158)', padding:'11px 45px 11px 20px'}}
										rel="tooltip" className="TekBtn vazgec "
										onClick={() => {
											this.cancelCurrentBank()
										}}>İptal
								</button>


							</div>
							<div className="col-6"></div>
							<div className="col-3">
								<button type="button" data-toggle="tooltip" data-placement="bottom"
										style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)', padding:'11px 45px 11px 20px'}}
										rel="tooltip" className="TekBtn ekle "
										onClick={() => {
											this.addBank()
										}}>Ekle
								</button>
							</div>
						</nav>
					</ModalFooter>
				</Modal>
			</div>
		)
	}
}

export default CustomerBankInfo;